// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed5e1596","292":"a10404c3","455":"3907e95f","977":"83c4c41b"}[chunkId] + ".chunk.js";
};